import OnlineRenewalPurchaseRenewal from '@/components/OnlineRenewalPurchaseRenewal.vue'
import PurchaseOnlineInfo from '@/components/purchase_policy/PurchaseOnlineInfo.vue'
import { Store } from 'vuex';

export default {
    components: {
        OnlineRenewalPurchaseRenewal,
        PurchaseOnlineInfo
    },
    Store,
    data() {
        return {
            promoCode: "",
            promoCodeError: "",
            validatingPromoCode: false,
            validPromoCode: false,
            loading: {
                summary: true,
                cover: true,
                policy_holder: true,
                premium_breakdown: true
            },
            session_quote: {
                "quote_id": "",
                "loi": null,
                "admin_fee": "0.00",
                "user_type": "educator",
                "session_id": "",
                "addons_base": "0.00",
                "addons_total": "0.00",
                "output_pa_uw": "0.00",
                "admin_fee_gst": "0.00",
                "dr_addon_base": "0.00",
                "tl_addon_base": "0.00",
                "non_member_fee": "0.00",
                "output_pa_base": "0.00",
                "output_pl_base": "0.00",
                "addons_base_gst": "0.00",
                "activities_count": "0.00",
                "ext_discount_off": null,
                "output_pa_broker": "0.00",
                "output_pa_uw_gst": "0.00",
                "output_pl_broker": "0.00",
                "transaction_type": "New Policy",
                "dr_addon_base_gst": "0.00",
                "ext_discount_code": null,
                "ext_discount_type": null,
                "flat_discount_off": null,
                "npc_discount_code": null,
                "pricing_matrix_id": null,
                "tl_addon_base_gst": "0.00",
                "ext_discount_value": "0.00",
                "flat_discount_code": null,
                "flat_discount_type": null,
                "non_member_fee_gst": "0.00",
                "output_pa_base_gst": "0.00",
                "output_pl_base_gst": "0.00",
                "flat_discount_value": "0.00",
                "npc_discount_amount": "0.00",
                "output_pl_qual_disc": "0.00",
                "npc_discount_code_yn": null,
                "output_pa_broker_gst": "0.00",
                "output_pa_stamp_duty": "0.00",
                "output_pl_broker_gst": "0.00",
                "output_pl_stamp_duty": "0.00",
                "policy_premium_total": "0.00",
                "activities_broker_fee": "0.00",
                "output_membership_base": "0.00",
                "activities_total_premium": "0.00",
                "additional_branches_base": "0.00",
                "activities_broker_fee_gst": "0.00",
                "additional_branches_broker": "0.00",
                "output_membership_base_gst": "0.00",
                "activities_prorated_premium": "0.00",
                "additional_branches_base_gst": "0.00",
                "additional_branches_total_fee": "0.00",
                "additional_branches_broker_gst": "0.00",
                "additional_branches_stamp_duty": "0.00",
                "pl_total": "0",
                "pa_total": "0",
                "membership_total": "0",
                "broker_fee_total": "0",
                "stamp_duty_total": "0",
                "total_gst": "0",
                "token": document.getElementsByName('cmb-api-token')[0].content,
                "token_name": "cmb-auth"
              },
              purchaseDisabled: true
        }
    },
    props: [
        "policyExpiry",
        "paymentTerms",
        "totalPayable",
        "summaryData",
        "premiumBreakdownData",
        "policyHolderInformationData",
        "eligibleForRenewal",
        "parent"
    ],
    computed: {
        policyExpiryFormatted() {
            return moment(this.session_quote.policy_premium_total, 'YYYY-MM-DD').format('Do MMM YYYY');
        },
        policy_premium_total() {
            const _premium_total = this.session_quote.policy_premium_total;
            let _total = _premium_total;
            switch(this.$store.state.sessionDetails.properties.payment_terms) {
                case "monthly":
                case "fortnightly":
                    _total = (_premium_total * 1.1).toFixed(2);
                    break;
            }
            return _total;
        },
        monthlyPayment() {
            return ((Number(this.policy_premium_total) - 195) / 10).toFixed(2)
        },
        fortnightlyPayment() {
            return ((Number(this.policy_premium_total) - 195) / 22).toFixed(2)
        }
    },
    methods: {
        updatePaymentTermsAndSummary(term){
            this.$emit('updatePaymentTerms', term);
            this.updatePremiumBreakdownTable();
        },
        backToPrevious() {
            this.parent.$refs.NewBusinessFDALegalService.FDALegalServiceSubmitted = false;
            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep - 1
            });
        },
        checkEligabilityForRenewal() {
            // if 1 of the 3 is "true/yes" = policy not eligible
            return !(this.$store.state.sessionDetails.properties.previous_policies 
                || this.$store.state.sessionDetails.properties.previous_claims
                || this.$store.state.sessionDetails.properties.existing_claims);
        },
        validatePromoCode(){
            this.validatingPromoCode = true;
            let digits = this.promoCode.split("NPC")[1];
            if (this.promoCode &&
                this.promoCode.indexOf("NPC") === 0 &&
                digits.length === 8 && Number(digits)) {
                
                this.promoCodeError = "";
                this.validatingPromoCode = false;
                this.validPromoCode = true;
                this.updatePromoCodePayload();
            } else {
                this.promoCodeError = "Invalid promo code";
                this.validatingPromoCode = false;
            }
        },
        async updatePromoCodePayload(){
            this.session_quote["npc_discount_amount"] = "15.00";
            this.session_quote["npc_discount_code"] = this.promoCode;
            this.session_quote["npc_discount_code_yn"] = true;
            this.updatePremiumBreakdownTable();

            let request = {
                method: 'put',
                url: `${this.baseURL}/main/update_npc_discount.json`,
                params: {
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                },
                data: {
                    properties: {
                        npc_discount_amount: "15.00",
                        npc_discount_code: this.promoCode,
                        npc_discount_code_yn: true
                    }
                }
            }

            let response = await this.$store.dispatch('fetchData', request);
        },
        setTablesData() {
            this.updateSummaryTable();
            this.updateCoverTable();
            this.updatePolicyHolderInformationTable();
            this.updatePremiumBreakdownTable();

            this.loading.summary = false;
            this.loading.cover = false;
            this.loading.policy_holder = false;
            this.loading.premium_breakdown = false;
        },
        updateSummaryTable() {
            const _data = [
                { "Package": this.$store.state.sessionDetails.properties.package },
                { "Start Date" : this.$store.state.sessionDetails.properties.policy_start },
                { "End Date" : this.$store.state.sessionDetails.properties.policy_expiry }
            ]

            document.getElementById('summary-table').tableData = _data;
        },
        updateCoverTable() {
            const _data = [
                {"Public Liability": this.valueDisplay(this.session_quote.output_pl_base, 'public_liability', `20,000,000`)},
                {"Personal Accident": this.valueDisplay(Number(this.session_quote.output_pa_base) > 0 ? true : false, 'personal_accident')},
                {"Legal Assistance *": this.valueDisplay(this.session_quote.tl_addon_base, "telephone legal assistance")},
                {"Debt Recovery *": this.valueDisplay(this.session_quote.dr_addon_base, "debt recovery")}
            ]
            document.getElementById('cover-table').tableData = _data;
        },
        updatePolicyHolderInformationTable() {
            const _data = [
                { "Insured Name" : `${this.$store.state.sessionDetails.properties.first_name} ${this.$store.state.sessionDetails.properties.last_name}` },
                { "Risk Address" : `${this.getAddress("risk")}` },
                { "Mailing Address" : `${this.getAddress("mailing")}` },
                { "Registered Service" : `${(this.$store.state.sessionDetails.properties.registered_service).service_name}` },
            ]

            document.getElementById('policy-holder-information-table').tableData = _data;
        },
        updatePremiumBreakdownTable() {
            const _sq = this.session_quote;

            const _pa_total = Number(_sq.output_pa_base) + Number(_sq.output_pa_base_gst);
            const _pl_total = Number(_sq.output_pl_base) + Number(_sq.output_pl_base_gst);
            const _membership_total = Number(_sq.output_membership_base) + Number(_sq.output_membership_base_gst);
            const _brokerfee_total = Number(_sq.output_pl_broker) + Number(_sq.output_pl_broker_gst) + Number(_sq.output_pa_broker) + Number(_sq.output_pa_broker_gst) + Number(_sq.activities_broker_fee) + Number(_sq.activities_broker_fee_gst) + Number(_sq.additional_branches_broker) + Number(_sq.additional_branches_broker_gst);
            const _stamp_duty_total = Number(_sq.output_pl_stamp_duty) + Number(_sq.output_pa_stamp_duty) + Number(_sq.additional_branches_stamp_duty);
            const _total_gst_total = Number(_sq.output_pl_base_gst) + Number(_sq.output_pl_broker_gst) + Number(_sq.output_pa_base_gst) + Number(_sq.output_pa_broker_gst) + Number(_sq.output_membership_base_gst) + Number(_sq.addons_base_gst) + Number(_sq.activities_broker_fee_gst) + Number(_sq.additional_branches_base_gst) + Number(_sq.additional_branches_broker_gst);

            const _space = { "&nbsp;" : "&nbsp;" };
            const _membership = { "Membership *" : `$${_membership_total.toFixed(2)}` };
            const _pl_premium = { "Public Liability Premium" : `$${_pl_total.toFixed(2)}` };
            const _pa_premium = { "Personal Accident Premium" : `$${_pa_total.toFixed(2)}` };
            const _legal_services = { "FDCA Legal Services *" : `$${_sq.addons_total}` };
            const _broker_fee = { "FDCA Broker Fee *" : `$${_brokerfee_total}` };
            const _elantis_interest = { "Elantis Interest" : `$${(_sq.policy_premium_total * 0.10).toFixed(2)}` }
            const _stamp_duty = { "Stamp Duty" : `$${_stamp_duty_total.toFixed(2)}` };
            const _total_gst = { "Total GST Included" : `$${_total_gst_total.toFixed(2)}` };
            const _total_payable = { "Total Payable" : `$${this.policy_premium_total}` };

            const _data = [];
            _data.push(_membership);
            _data.push(_pl_premium);
            _data.push(_pa_premium);
            _data.push(_space);
            _data.push(_legal_services);
            _data.push(_space);
            _data.push(_broker_fee);
            _data.push(_stamp_duty);
            _data.push(_space);

            if(this.$store.state.sessionDetails.properties.payment_terms !== "annual") {
                _data.push(_elantis_interest);
            }

            if (this.session_quote["npc_discount_code_yn"]){
                let diff = this.session_quote.policy_premium_total - this.session_quote.npc_discount_amount;
                const _discount = { "Discount" : `-$${this.session_quote.npc_discount_amount}` };
                _data.push(_discount);
                _total_payable["Total Payable"] = `$${diff}`;
            }

            _data.push(_space);
            _data.push(_total_gst);
            _data.push(_total_payable);

            document.getElementById('premium-breakdown-table').tableData = _data;
        },
        getAddress(_type) {
            let _address = "";
            const _type_field = _type === "risk" ? "is_risk_address" : "is_mailing_address";
            const _addresses = (this.$store.state.sessionDetails.properties.addresses);
            _addresses.forEach(function(_item, _index) {
                if(_item[_type_field] === true) {
                    _address = `${_item.address.address1} ${_item.address.address2} <br /> ${_item.address.suburb} ${_item.address.state} ${_item.address.postcode}`;
                }
             });
             return _address;
        },
        valueDisplay: function(value, display, alternate_display) {
            let return_value;
            
            if(value && Number(value) > 0) {

                let string;
                switch(display) {
                    case 'public_liability':
                        string = `$${alternate_display}`;
                        break;
                    case 'personal_accident':
                        string = "$30,000";
                        break;
                    case 'telephone legal assistance':
                        const _tl = Number(value).toFixed(2) + " + GST";
                        string = `$${_tl}`;
                        break;
                    case 'debt recovery': 
                    const _dr = Number(value).toFixed(2) + " + GST";
                        string = `$${_dr}`;
                        break; 
                    case 'gst_registered':
                        string = 'Verified';
                    break;
                    case 'nsw_small_business':
                        string = 'Eligible';
                    break;
                }
                
                return_value = `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;${string}`;
            } else {
                return_value = `<span class='icon-cancel' style='color: #DA6868;'></span>`;
            }
            return return_value;
        },
        async getQuote(retry=0)  {
            this.loading.summary = true;
            this.loading.cover = true;
            this.loading.policy_holder = true;
            this.loading.premium_breakdown = true;

            let sessionID = localStorage.getItem("session_id");
            let _options = {
                method: 'get',
                url: `/utilities/create_quote_draft.json`,
                params: {   
                    session_id: sessionID,
                    env:  this.$store.state.env,
                    email: this.$store.state.sessionDetails.properties.email
                }
            };

            let response = await this.$store.dispatch('fetchData', _options)
                .then(({data}) => ({ state: true, result: data }))
                .catch(error => ({ state:  false, result: error }));

            if(response.state) {

                let payload = {
                    id: sessionID,
                    properties: {
                        quote_id: response.result.quote_id
                    }
                }

                await serviceModule.session.addNewSession(payload);
                if (Number(response.result.quote_id) > 0) {
                    let _interval = setInterval(async () => {
                        let _options2 = {
                            method: 'get',
                            url: `/main/get_quote_by_id_decimal.json`,
                            params: {   
                                target: "quotes",
                                id: response.result.quote_id,
                                token: document.getElementsByName('cmb-api-token')[0].content,
                                token_name: "cmb-auth"
                            }
                        };
            
                        let response2 = await this.$store.dispatch('fetchData', _options2);
                        
                        if(response2.data.items.results.length > 0) {
                            if(response2.data.items.results[0].properties.policy_premium_total > 0) {
                                clearInterval(_interval); 
                                this.purchaseDisabled = false;
                                this.session_quote = response2.data.items.results[0].properties;
                                this.setTablesData();
                            }
                        }
                    }, 5000);
                } 
            } else if(retry !== 3){
                return this.getQuote(retry+1)
            }
        }
    },
    mounted() {
        this.getQuote();
    }
}